import { Divider } from 'antd';
import styled from 'styled-components';
import { Menu as StyledMenu } from 'components/organisms/projects/project-sidebar/menu.style';
import { BodyShort01 } from 'components/styles';

export const SidebarWrapper = styled.div`
  padding-bottom: var(--spacing-06);
`;

export const Menu = styled(StyledMenu)`
  .ant-menu-submenu-expand-icon,
  .ant-menu-submenu-arrow {
    left: 0;
    right: auto;
    width: var(--spacing-05);
  }

  .ant-menu-sub .ant-menu-item {
    font-weight: normal;
    padding-left: var(--spacing-06) !important;
    padding-right: 0;
  }

  .ant-menu-item,
  .ant-menu-submenu-title {
    padding: var(--spacing-05) !important;

    span {
      display: block;
      width: 100%;
    }
  }
`;

export const ItemGroup = styled(Menu.ItemGroup)`
  margin: var(--spacing-05) auto var(--spacing-03);

  .ant-menu-item-group-title {
    padding: 0px;
  }
`;

export const GroupTitle = styled.span`
  ${BodyShort01};
  text-overflow: ellipsis;
  overflow: hidden;
  color: var(--gray-80);
`;

export const MenuTitle = styled.span`
  width: 130px !important;
  text-overflow: ellipsis;
  overflow: hidden;
  ${BodyShort01};
`;

export const SpaceDivider = styled(Divider)`
  min-width: 224px;
  width: 224px;
  margin: var(--spacing-06) auto auto;
`;

export const SearchContainer = styled.div`
  padding: var(--spacing-05);
  padding-left: var(--left-spacing);
  padding-bottom: 0;
`;
